__webpack_require__.p = "https://bmidxbturkeyplprod.netlify.app/";